import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "projectList__content" }
const _hoisted_3 = { class: "fl-row" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "separator" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "separator" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("确定要 "),
  /*#__PURE__*/_createElementVNode("b", null, "删除"),
  /*#__PURE__*/_createTextVNode(" 该角色?")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "text-error"
}, "删除", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "separator" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_app_table = _resolveComponent("app-table")!
  const _component_action_drawer = _resolveComponent("action-drawer")!
  const _component_change_owner_modal = _resolveComponent("change-owner-modal")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { class: "utils__pageContainer withRouteTab projectList" }, {
    title: _withCtx(() => [
      _createElementVNode("div", {
        innerHTML: _ctx.sldPageTitle('#1890ff', '角色管理')
      }, null, 8, _hoisted_1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_form, {
          class: "fl-clean projectList__filterForm",
          model: _ctx.filterParams,
          layout: 'inline'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  href: "#",
                  class: "ant-btn ant-btn-primary",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.doWith('create')), ["prevent"]))
                }, " 新建角色 ")
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "角色名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.filterParams.name,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterParams.name) = $event)),
                  "allow-clear": ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  ghost: "",
                  onClick: _ctx.onRefreshTable
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("查询")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createVNode(_component_app_table, {
          ref: "tableRef",
          size: "default",
          "row-key": "roleId",
          columns: _ctx.tableColumns,
          data: _ctx.loadTableData,
          "show-pagination": true
        }, {
          num: _withCtx(({ record }) => [
            (!['初始管理员'].includes(record.roleName))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "underline",
                  to: { name: 'role.staff', params: { id: record.roleId } }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(record.num), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  class: "underline",
                  to: { name: 'role.owner', params: { id: record.roleId } }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(record.num), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
          ]),
          action: _withCtx(({ record }) => [
            _createElementVNode("span", _hoisted_3, [
              (!['员工'].includes(record.roleName))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "#",
                    onClick: _withModifiers(($event: any) => (_ctx.doWith('view', record.roleId)), ["prevent"])
                  }, "详情", 8, _hoisted_4))
                : (_openBlock(), _createElementBlock("span", _hoisted_5, "---")),
              (!['初始管理员', '员工', '部门主管'].includes(record.roleName))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _hoisted_6,
                    _createVNode(_component_router_link, {
                      to: { name: 'role.staff', params: { id: record.roleId } }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("管理人员")
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ], 64))
                : _createCommentVNode("", true),
              (!['初始管理员', '员工', '超级管理员', '部门主管'].includes((record.roleName)))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _hoisted_7,
                    _createVNode(_component_a_popconfirm, {
                      placement: "top",
                      onConfirm: ($event: any) => (_ctx.onDelItem(record))
                    }, {
                      title: _withCtx(() => [
                        _hoisted_8
                      ]),
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 2
                    }, 1032, ["onConfirm"])
                  ], 64))
                : _createCommentVNode("", true),
              (['初始管理员', '部门主管'].includes(record.roleName))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    _hoisted_10,
                    _createVNode(_component_router_link, {
                      to: { name: 'role.owner', params: { id: record.roleId } }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("查看人员")
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["columns", "data"])
      ]),
      _createVNode(_component_action_drawer, {
        ref: "actionDrawerRef",
        onComplete: _ctx.onRefreshTable
      }, null, 8, ["onComplete"]),
      _createVNode(_component_change_owner_modal, {
        ref: "changeOwnerRef",
        onComplete: _ctx.loadData
      }, null, 8, ["onComplete"])
    ]),
    _: 1
  }))
}